import React, { useEffect, useRef, useState } from "react";
import { ArrowUpRight, Check } from "lucide-react";
import { SERVICES } from "../mock";

export default function Services() {
  const ref = useRef(null);
  const [active, setActive] = useState(null);

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add("in-view")),
      { threshold: 0.12 }
    );
    ref.current?.querySelectorAll(".reveal").forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <section id="servicios" ref={ref} className="relative py-24 md:py-36" style={{ background: "#001d3f" }}>
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <p className="reveal uppercase tracking-[0.35em] text-[12px] mb-5" style={{ color: "#e55b36" }}>{SERVICES.eyebrow}</p>
            <h2 className="reveal font-display font-semibold text-white text-[40px] md:text-[64px] leading-[1.02] max-w-2xl">{SERVICES.heading}</h2>
          </div>
          <p className="reveal max-w-sm text-[16px] md:text-[18px]" style={{ color: "#b1cdff" }}>{SERVICES.subheading}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-5 md:gap-7">
          {SERVICES.items.map((s, i) => (
            <div
              key={s.num}
              className="reveal group relative rounded-3xl overflow-hidden p-7 md:p-9 transition-transform duration-300 hover:-translate-y-1"
              style={{ background: "#00101f", border: "1px solid rgba(177,205,255,0.1)" }}
              onMouseEnter={() => setActive(i)}
              onMouseLeave={() => setActive(null)}
            >
              <div className="absolute -top-10 -right-6 font-display font-semibold select-none pointer-events-none transition-opacity duration-300" style={{ fontSize: 160, lineHeight: 1, color: s.color, opacity: active === i ? 0.16 : 0.07 }}>
                {s.num}
              </div>
              <div className="relative">
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <span className="font-display text-[14px]" style={{ color: s.color }}>{s.num}</span>
                    <h3 className="font-display font-semibold text-white text-[26px] md:text-[32px] leading-tight mt-1">{s.name}</h3>
                  </div>
                  <span className="shrink-0 grid place-items-center h-11 w-11 rounded-full transition-all duration-300 group-hover:rotate-45" style={{ background: s.color, color: "#00101f" }}>
                    <ArrowUpRight size={20} />
                  </span>
                </div>
                <p className="mt-4 text-[16px] leading-relaxed" style={{ color: "#b1cdff" }}>{s.desc}</p>
                <ul className="mt-6 space-y-3">
                  {s.points.map((p) => (
                    <li key={p} className="flex items-start gap-3 text-[15px] text-white/90">
                      <span className="mt-0.5 shrink-0 grid place-items-center h-5 w-5 rounded-full" style={{ background: "rgba(229,91,54,0.15)", color: s.color }}>
                        <Check size={13} />
                      </span>
                      {p}
                    </li>
                  ))}
                </ul>
                <a href="#contacto" className="inline-flex items-center gap-1.5 mt-7 font-semibold text-[15px] transition-colors" style={{ color: s.color }}>
                  Consultar <ArrowUpRight size={16} />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
